import { XMarkIcon } from '@heroicons/react/20/solid';
import { SkuFacetState, hasActiveFacets } from './skuFacets';

export interface SkuActiveFiltersProps {
  facets: SkuFacetState;
  onClearHierarchy: () => void;
  onRemoveBrand: (value: string) => void;
  onClearAll: () => void;
}

const hierarchyChipLabel = (facets: SkuFacetState): string | null => {
  if (facets.unassigned) return 'Unassigned';
  if (facets.subCategory) return `Sub-category: ${facets.subCategory}`;
  if (facets.category) return `Category: ${facets.category}`;
  return null;
};

function FilterChip({
  label,
  onRemove,
}: {
  label: string;
  onRemove: () => void;
}) {
  return (
    <span className='inline-flex items-center gap-1.5 rounded-lg bg-blue-50 px-2.5 py-1 text-sm font-medium text-primary'>
      {label}
      <button
        type='button'
        aria-label={`Remove ${label} filter`}
        onClick={onRemove}
        className='rounded hover:text-blue-800'
      >
        <XMarkIcon className='h-4 w-4' />
      </button>
    </span>
  );
}

export function SkuActiveFilters({
  facets,
  onClearHierarchy,
  onRemoveBrand,
  onClearAll,
}: SkuActiveFiltersProps) {
  if (!hasActiveFacets(facets)) return null;

  const hierarchyLabel = hierarchyChipLabel(facets);

  return (
    <div className='flex flex-wrap items-center gap-2 font-inter'>
      {hierarchyLabel && (
        <FilterChip label={hierarchyLabel} onRemove={onClearHierarchy} />
      )}
      {[...facets.brands].map((brand) => (
        <FilterChip
          key={brand}
          label={`Brand: ${brand}`}
          onRemove={() => onRemoveBrand(brand)}
        />
      ))}
      <button
        type='button'
        onClick={onClearAll}
        className='ml-1 text-sm font-medium text-gray-500 hover:text-gray-900'
      >
        Clear all
      </button>
    </div>
  );
}
